export function blobToFile(
  blob: Blob,
  fileName: string = new Date().toDateString() + new Date().toLocaleTimeString()
) {
  return new File(
    [blob as any], // cast as any
    fileName,
    {
      lastModified: new Date().getTime(),
      type: blob.type,
    }
  );
}

export function isValidURL(str: string) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return pattern.test(str);
}

export function getVideoPath(q: string) {
  return process.env.PUBLIC_URL + `/videos/${q.replace("?", "")}`;
}

export function getUuid() {
  let d = Date.now();
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getRandom(min: number, max: number) {
  return Math.round(Math.random() * (max - min));
}
